// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"bE-z","shipmentMessage":"cE-z","shipmentNumber":"dE-z","trackingProgressContainer":"eE-z"};